import React, { PropTypes, Component } from 'react'
import styles from './styles'
import Hint from 'components/hint'

export default class HeaderCell extends Component {
  static propTypes = {
    cellHint: PropTypes.bool,
    baseClass: PropTypes.string,
    text: PropTypes.string,
  };

  constructor (props, context) {
    super(props, context)
  }

  render () {
    const { baseClass, text, cellHint } = this.props
    return (
      <div className={baseClass} >
        <span>{text}</span>
        {cellHint ?
          <Hint className={styles.cellHint}>{text}</Hint> : null
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/timesheet/cell/headerCell.jsx